import React from "react";

const VerticalDivider = ({ className }: { className?: string }) => {
  return (
    <div className={`vertical-divider ${className || ""}`}></div>
  );
};

export default VerticalDivider;
